import request from '@/request'
import { AUTH } from '@/data/api'

const rule = 'unique'
export const uniqueRule = extend => {
  extend(rule, {
    validate (value, { ignore }) {
      return new Promise(async resolve => {
        try {
          await request.post(AUTH.EXISTS, {
            'email': value,
            'ignore': ignore
          })
          resolve({
            valid: true
          })
        } catch (e) {
          resolve({
            valid: false
          })
        }
      })
    },
    params: ['ignore']
  }, {
    immediate: false
  })
}

export const uniqueMessage = {
  en: {
    [rule]: 'The {_field_} has already been taken.'
  },
  nl: {
    [rule]: 'De {_field_} is al bezet.'
  },
  de: {
    [rule]: 'Das {_field_} wurde bereits vergeben.'
  },
  es: {
    [rule]: 'El {_field_} ya ha sido tomado.'
  },
  fr: {
    [rule]: 'Le {_field_} a déjà été pris.'
  }
}
